import { fromB58, splitGenericParameters } from "@iota/bcs";
const TX_DIGEST_LENGTH = 32;
function isValidTransactionDigest(value) {
  try {
    const buffer = fromB58(value);
    return buffer.length === TX_DIGEST_LENGTH;
  } catch (e) {
    return false;
  }
}
const IOTA_ADDRESS_LENGTH = 32;
function isValidIotaAddress(value) {
  return isHex(value) && getHexByteLength(value) === IOTA_ADDRESS_LENGTH;
}
function isValidIotaObjectId(value) {
  return isValidIotaAddress(value);
}
function parseTypeTag(type) {
  if (!type.includes("::")) return type;
  return parseStructTag(type);
}
function parseStructTag(type) {
  const [address, module] = type.split("::");
  const rest = type.slice(address.length + module.length + 4);
  const name = rest.includes("<") ? rest.slice(0, rest.indexOf("<")) : rest;
  const typeParams = rest.includes("<") ? splitGenericParameters(rest.slice(rest.indexOf("<") + 1, rest.lastIndexOf(">"))).map(
    (typeParam) => parseTypeTag(typeParam.trim())
  ) : [];
  return {
    address: normalizeIotaAddress(address),
    module,
    name,
    typeParams
  };
}
function normalizeStructTag(type) {
  const { address, module, name, typeParams } = typeof type === "string" ? parseStructTag(type) : type;
  const formattedTypeParams = typeParams?.length > 0 ? `<${typeParams.map(
    (typeParam) => typeof typeParam === "string" ? typeParam : normalizeStructTag(typeParam)
  ).join(",")}>` : "";
  return `${address}::${module}::${name}${formattedTypeParams}`;
}
function normalizeIotaAddress(value, forceAdd0x = false, validate = false) {
  let address = value.toLowerCase().replace(/ /g, "");
  if (!forceAdd0x && address.startsWith("0x")) {
    address = address.slice(2);
  }
  address = `0x${address.padStart(IOTA_ADDRESS_LENGTH * 2, "0")}`;
  if (validate && !isValidIotaAddress(address)) {
    throw new Error(`Invalid IOTA address: ${value}`);
  } else {
    return address;
  }
}
function normalizeIotaObjectId(value, forceAdd0x = false, validate = false) {
  return normalizeIotaAddress(value, forceAdd0x, validate);
}
function isHex(value) {
  return /^(0x|0X)?[a-fA-F0-9]+$/.test(value) && value.length % 2 === 0;
}
function getHexByteLength(value) {
  return /^(0x|0X)/.test(value) ? (value.length - 2) / 2 : value.length / 2;
}
export {
  IOTA_ADDRESS_LENGTH,
  isValidIotaAddress,
  isValidIotaObjectId,
  isValidTransactionDigest,
  normalizeIotaAddress,
  normalizeIotaObjectId,
  normalizeStructTag,
  parseStructTag
};
//# sourceMappingURL=iota-types.js.map
